import React, { useEffect } from "react";

import useGlobalSearch from "hooks/useGlobalSearch";
import Tooltip from "components/tooltip";

import { SEARCH_TYPES, TITLE_MAX_LENGTH } from "../constants";
import styles from "./recentSearch.scss";

const {
    recent_search,
    list_container,
    search_list,
    clock_icon,
    search_text,
    search_content,
    ellipsis,
} = styles;

export default function RecentSearch({ handleSearchSelect }) {
    const { fetchRecentSearches, recentSearch: { contents: recentSearch } } = useGlobalSearch();

    useEffect(() => {
        fetchRecentSearches();
    }, []);

    return (
        <div className={recent_search}>
            {recentSearch?.length > 0 && (
                <div className={list_container}>
                    {/* <h4>Recent Search</h4> */}
                    <ul className={search_list}>
                        {recentSearch.map(search => {
                            const { id, title } = search;
                            return (
                                <li key={id}>
                                    <a href={search.handlerId} role="button" onClick={(event) => handleSearchSelect({ event, type: SEARCH_TYPES.RECENT, search })}>
                                        <span className={clock_icon}>
                                            <i className="aeh-icon-outlined-clock-icon"></i>
                                        </span>
                                        <div className={search_content}>
                                            {title.length > TITLE_MAX_LENGTH ? <Tooltip
                                                parent={<p className={`${search_text} ${ellipsis}`}>{title}</p>}
                                                content={title}
                                            /> : <p className={`${search_text} ${ellipsis}`}>{title}</p>}
                                        </div>
                                    </a>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            )}
        </div>
    );    
}
